import { useCallback, useEffect, useRef } from "react";

const SWIPE_THRESHOLD_PX = 50;
const VERTICAL_TOLERANCE_PX = 80;

// 预览大图时的左右切换交互：键盘左右键 + 触摸滑动。
// enabled 为 false 时（如非图片类型预览）不绑定任何手势/快捷键。
export function usePreviewNavigation({ open, enabled = true, onPrev, onNext }) {
    const touchRef = useRef(null);
    const multiTouchRef = useRef(false);

    useEffect(() => {
        if (!open || !enabled) {
            return undefined;
        }
        const handleKeyDown = (event) => {
            if (event.key === "ArrowLeft") {
                onPrev?.();
            } else if (event.key === "ArrowRight") {
                onNext?.();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [open, enabled, onPrev, onNext]);

    const onTouchStart = useCallback(
        (event) => {
            if (!enabled) {
                return;
            }
            if (event.touches.length !== 1) {
                multiTouchRef.current = true;
                touchRef.current = null;
                return;
            }
            const touch = event.touches[0];
            touchRef.current = touch ? { x: touch.clientX, y: touch.clientY } : null;
        },
        [enabled]
    );

    const onTouchEnd = useCallback(
        (event) => {
            if (!enabled || multiTouchRef.current || !touchRef.current) {
                if (event.touches.length === 0) {
                    multiTouchRef.current = false;
                    touchRef.current = null;
                }
                return;
            }
            const touch = event.changedTouches[0];
            const start = touchRef.current;
            touchRef.current = null;
            if (!touch) {
                return;
            }
            const dx = touch.clientX - start.x;
            const dy = touch.clientY - start.y;
            if (Math.abs(dx) < SWIPE_THRESHOLD_PX || Math.abs(dy) > VERTICAL_TOLERANCE_PX) {
                return;
            }
            if (dx > 0) {
                onPrev?.();
            } else {
                onNext?.();
            }
        },
        [enabled, onPrev, onNext]
    );

    return { swipeHandlers: { onTouchStart, onTouchEnd } };
}
